var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-layout',{staticClass:"align-center mt-4 mt-sm-0",class:{
            'reverse': _vm.reverse
        }},[_vm._t("default")],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }